module.exports = __webpack_public_path__ + "static/media/yelp.4f82bc45.svg";